import React from 'react';
import PriceDetailsRoot from '../PriceDetails';
const PriceDetailsExtendedVariant = props => {
    return React.createElement(PriceDetailsRoot, Object.assign({}, props, { variant: "extended-details" }));
};
export default PriceDetailsExtendedVariant;
